import React from 'react';

function Preloader() {
  return (
    <div className='preloader style-3'>
      <div className='loader'>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  );
}

export default Preloader;
